// extracted by mini-css-extract-plugin
export var modal = "_ua-0";
export var table = "_ua-1";